if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.classicCup = this.closest('[data-ccs-classic-cup="true"]') !== null;
      this.elements.viewer.addEventListener('slideChanged', this.classicCup ? this.onSlideChanged.bind(this) : debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const current = event.detail.currentElement;
      if (!current) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach(item => item.classList.toggle('is-active', item === current));
      const counter = this.closest('[id^="MainProduct-"]')?.querySelector('[data-ccs-gallery-current]');
      if (counter) counter.textContent = event.detail.currentPage;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          const canonicalColour = value => {
            if (!['nl','fr'].includes(document.documentElement.lang.split('-')[0])) return value;
            const aliases = {"zwart": "black", "noir": "black", "wit": "white", "blanc": "white", "blauw": "blue", "bleu": "blue", "zilver": "silver", "argenté": "silver", "bruin": "brown", "marron": "brown", "goud": "gold", "doré": "gold", "pistache": "pistachio", "groen": "green", "vert": "green", "paars": "purple", "violet": "purple", "oranje": "orange", "orange": "orange", "roze": "pink", "rose": "pink", "rood": "red", "rouge": "red", "geel": "yellow", "jaune": "yellow", "beige": "beige", "marineblauw": "navy", "bleu marine": "navy", "grijs": "gray", "gris": "gray", "ivoor": "ivory", "ivoire": "ivory", "lichtblauw": "light blue", "bleu clair": "light blue", "brons": "bronze", "bronze": "bronze", "roségoud": "rose gold", "or rose": "rose gold", "lila": "lilac", "lilas": "lilac", "abrikoos": "apricot", "abricot": "apricot", "lavendel": "lavender", "lavande": "lavender", "turkoois": "turquoise", "argent": "silver", "or": "gold", "grenade": "navy", "navy blue": "navy"};
            const normalized = String(value || '').toLowerCase().trim();
            return aliases[normalized] || normalized;
          };
          if (canonicalColour(slide.dataset.alt) === canonicalColour(currentVariant[this.filteringOption]) || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      if (this.classicCup && this.elements.thumbnails) {
        const track = activeMedia.parentElement;
        track.scrollTo({ left: track.scrollLeft + activeMedia.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'instant' });
      } else window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
